module.exports = __webpack_public_path__ + "static/wereboar-a45420a19f446edce880eac9355bbc79.jpg";